export const AUTH_CONFIG = {
  apiBaseUrl: process.env.VUE_APP_BASE_URL,
  forceLogin: false,
  appConfigPath: '/System/AppConfig',
  oidcLoginPath: '/Account/oidcLogin',
  oidcTicketLoginPath: '/Account/oidcTicketLogin',
  currentUserPath: '/UserInfo/current'
}

export const ACCESS_TOKEN_KEY = 'ACCESS-TOKEN'
